export default {
    txt_welcome: 'Willkommen beim Gebrauch des intelligenten Profiltiefe-Detektors Tyrehub',
    txt_dataover: 'Übersicht',
    txt_chance: 'Verkaufsleiter',
    txt_device: 'Chance',
    txt_chinese: 'Chinese',
    txt_english: 'English',
    txt_malay: 'Malay',
    txt_german: 'German',
    txt_reports: 'Geschichte',
    txt_setting: 'Eingestellt',
    txt_dymanager: 'Mitarbeiter-Management',
    txt_account: 'Kontonummer',
    txt_userstatus: 'Benutzeridentität',
    txt_name: 'Name',
    txt_contactway: 'Kontakt',
    txt_accountsafe: '账号安全',
    txt_basicinfo: 'Grundlegende Informationen',
    txt_updatepassword: 'Passwort ändern',
    txt_storeinfomation: 'Daten der Filiale',
    txt_storename: 'Name',
    txt_storephone: 'Telefon',
    txt_storeaddress: 'Adresse der Filiale',
    txt_AppInfomation: 'App信息',
    txt_currentversion: '当前版本',
    txt_software: 'Software-Update',
    txt_loginout: 'Login beenden',
    txt_updatelanguage: 'Sprache',
    txt_updateto: '更新至',
    txt_zwgx: '暂无更新',
    txt_dz: 'Geschäftsleiter',
    txt_sh: 'marchand',
    txt_dy: 'Employees',
    txt_bdsj: 'Handy binden',
    txt_shxx: 'Händlerinformationen',
    txt_shname: 'Händler',
    txt_ssmd: '所属门店',
    txt_bdsb: 'Bindung',
    txt_mendian: '门店',


    //数据总览模块
    txt_sTime: 'Zeit Slot',
    txt_car_check: 'Auto-Prüfrate',
    txt_findchance: 'Chance finden',
    txt_trackchace: 'Tracking',
    txt_transform: 'Konvensionsrate',
    txt_TotalData: 'Übersicht',
    txt_xxsj: 'Detaillierte Daten',
    txt_zhsj: 'Konvensionsrate',
    txt_TireWear: '轮胎磨损',
    txt_DataHopper: '数据漏斗',
    txt_jdcc: 'Automenge',
    txt_CheckCar: 'Gescannte Automenge',
    txt_ChanceNum: 'Verkaufsleiter',
    txt_TrackNum: 'Verfolgte Automenge',
    txt_TranseformNum: 'Konvensionsrate',
    txt_UnTrack: 'Unverfolgt',
    txt_l: 'Verteilung ',
    txt_Time: 'Voraussichtliche Zeit',
    txt_Device: 'Chance',
    txt_car_plate: '车牌',
    txt_Wear: 'Abnutzung',
    txt_Pwear: 'ungleichmäßige',
    txt_NoData: '暂无数据',
    txt_GoodState: 'Normal',
    txt_Border: 'Kritisch',
    txt_replace: 'Sofort ersetzen',
    txt_Total_Check: '检测总车次',
    txt_pmqk: '偏磨情况',
    txt_LightWear: 'Leicht',
    txt_GraveWear: 'Schwer',
    txt_hwtj: 'Rotation & dynamisches Gleichgewicht',
    txt_wxhw: 'Rotation ist unerforderlich',
    txt_xyhw: 'Rotation ist erforderlich',
    txt_jcxq: 'Detaillierte Daten',
    txt_zhxq: 'Konvensionsdetail',
    txt_cc: 'Automenge',
    txt_bfb: '百分比',
    txt_ltxs: 'Reifenverkauf',
    txt_sldw: '4-Rad-Ausrichtung',
    txt_ddlph: 'Rotation & dynamisches Gleichgewicht',
    txt_dphhh: 'dynamisches Gleichgewicht',
    txt_qt: 'Andere',
    txt_zhqs: 'Konvensionstendenz',
    txt_ltxl: 'Reifenverkauf',
    txt_ltfw: 'Reifenservice',
    txt_ckxq: 'Detaillierte Daten',
    txt_jt: 'Heute',
    txt_zt: 'Gestern',
    txt_bz: 'Diese Woche',
    txt_by: 'Dieser Monat',
    txt_sy: 'Letzter Monat',
    txt_jn: 'Dieses Jahr',
    txt_zhcl: 'Konvensionsmenge',
    txt_zhl: 'Konvensionsrate',
    txt_bfb: '百分比',
    txt_abjx: 'Verteilung der Reifenmenge im Grenzenstatus',
    txt_aljg: 'Verteilung der Reifenmenge im sofortigen Wechselstatus',
    txt_qwpm: 'Verteilung der Reifenmenge im einfachen unregelmäßigen Abnutzungsstatus',
    txt_ayzp: 'Verteilung der Reifenmenge im schlimmen unregelmäßigen Abnutzungsstatus',
    txt_lingt: '0条',
    txt_yt: '1条',
    txt_et: '2条',
    txt_st: '3条',
    txt_ft: '4条',

    //机会
    txt_xsjh: 'Verkaufsleiter',
    txt_gzz: 'Verfolgt',
    txt_clwb: 'Geschlossen',
    txt_ckbg: 'Überprüfen des BerichtsAbbrechen',
    txt_yxs: 'Alle Daten sind angezeigt',
    txt_zhuiz: 'Tracking',
    txt_tix: 'Erinnerung',
    txt_chuli: '处理',
    txt_yzh: 'Umgewandelt:',
    txt_wzh: '未转化',
    txt_gzsmts: '{0}检查出现问题，预计{1}来店里维修',
    txt_czbty: 'Autobesitzer ist nicht einverstanden',
    txt_yyx: 'Absicht haben',
    txt_ltyg: '轮胎1个',
    txt_ltkg: '轮胎2个',
    txt_ltsang: '轮胎3个',
    txt_ltsig: '轮胎4个',
    txt_jhcl: '机会处理',
    txt_jhztai: 'Status',
    txt_crquy: 'Region',
    txt_chuliry: 'Bearbeiter',
    txt_chulijg: 'Prüfergebnis',
    txt_zhuanhuanr: 'Konversionsinhalte',
    txt_zhuanhuaje: 'Konvensionsbeträge',
    txt_zhuanhuasj: 'Voraussichtliche Zeit',
    txt_zhuanhuayx: 'Geschätzte Zeit',
    txt_xuanzesj: 'Voraussichtliche Zeit',
    txt_tsdatawk: '机会状态为空无法保存数据',
    txt_qtxzhsj: '请在转化意向栏填写预期时间',
    txt_qtxzhnr: '请填写转化内容',
    txt_qtxzhsj: '请填写转化时间',
    txt_sbts: '数据保存失败，请检查网络',


    //设备
    txt_sbgl: '设备管理',
    txt_tj: 'Hinzufügen',
    txt_gdssb: '共{0}个设备',
    txt_sbbh: 'Gerätenummer',
    txt_gjbb: 'Hardwareversion',
    txt_tjsj: 'Hinzugefügter Zeitpunkt',
    txt_zdgx: '自动更新',
    txt_gxgj: 'Software-Update',
    txt_jieb: 'Ungebunden',
    txt_sbtsxx: '设备固件有新版本，点击更新固件按钮更新',
    txt_wjh: '未激活',
    txt_lix: 'Offline',
    txt_zaix: 'Online',
    txt_guz: '故障',
    txt_yijieb: 'Ungebunden',
    txt_yihuis: 'Recycelt',
    txt_gxsbgj: '更新设备固件',
    txt_gxsbgjts: '确定要更新设备固件吗',
    txt_socketdk: 'Keine Verbindung mit dem Server ist hergestellt. Bitte versuchen Sie es erneut',
    txt_cscgts: '更新固件请求发送成功',
    txt_jbsb: 'Ungebunden',
    txt_jbsbts: 'Bestätigen Sie, die Bindung des Geräts zu deaktivieren?',
    txt_tscg: 'Success',
    txt_zdgxgj: '自动更新固件',
    txt_gxgjts: 'Bestätigen Sie, das automatische Firmware-Update {0}?',
    txt_beiz: 'Bemerkung',
    txt_qtxbz: 'Bitte geben Sie Bemerkungen ein',
    txt_bdsbts: '本APP仅用于【手持式轮胎检测国际版】的设备，请确保您想绑定的设备型号正确',
    txt_qdksb: '请先打开设备',
    txt_dksbts1: '1、新设备，开机后将自动进入绑定引导',
    txt_dksbts2: '2、如果设备此前绑定过其他门店，请先在设备的"设置"菜单中点击解绑设备进行解绑，解绑后设备将自动进入绑定引导',
    txt_yjdksblw: '我已打开设备并联网',
    txt_xyb: 'Nächsten',
    txt_qsclj: '请使手持式设备扫描二维码连接',
    txt_qscts1: '设备扫码成功后会发出"嘀"声提示',
    txt_qscts2: '并提示您扫码成功',
    txt_sbtssmcg: '设备已提示扫码成功',
    txt_ddsblw: '等待设备联网',
    txt_zznlbd: 'Binding',
    txt_qszdd: '这可能需要花费几十秒，请稍作等待',
    txt_bdcg: 'Eine SIM-Karte wurde gefunden. Das Mobilfunknetz wird verwendet.',
    txt_tjcg: '添加成功',
    txt_tjcgts: 'Gratulieren Sie zum erfolgreichen Hinzufügen des Geräts. Bitte markieren Sie die Gerätename zur einfachen Identifizierung',
    txt_fhsblb: 'Zurück zur Geräteliste',
    txt_jxtjsb: 'Geräte weiter hinzufügen',
    txt_bzmc: '备注名称',


    //检测记录
    txt_sx: 'Auswählen',
    txt_khsj: 'Handy des Kunden',
    txt_cphm: 'Nummernschild',
    txt_cphm1: 'Nummernschild',
    txt_clxh: 'Autotyp',
    txt_xgbz: '修改备注',
    txt_gtfjl: '共 {0} 份记录',
    txt_jcsj: 'Inspektionsdauer',
    txt_jcsj1: 'Inspektionsdauer',
    txt_xzkssj: '选择开始时间',
    txt_xzjssj: '选择结束时间',
    txt_jcjg: 'Prüfergebnis',
    txt_msqk: 'Laufflächenabnutzung',
    txt_jygh: 'Sofort ersetzen',
    txt_zysh: 'Kritisch',
    txt_zcsy: 'Normal',
    txt_zc: 'Normal',
    txt_cz: 'Zurücksetzen',
    txt_qd: 'Bestätigen',
    txt_jcjgd: 'Prüfergebnis',
    txt_msqkd: 'Laufflächenabnutzung',
    txt_sldwd: '四轮定位',
    txt_jyghd: 'Sofort ersetzen',
    txt_zysh: 'Kritisch',
    txt_zcsyd: 'Normal',
    txt_xdwd: '需定位',
    txt_xzyd: '需注意',
    txt_zcd: 'Normal',
    txt_bgxq: '报告详情',
    txt_ljdy: '连接打印',
    txt_fwmd: 'Händlerinformationen',
    txt_mddz: 'Adresse der Filiale',
    txt_jcsb: 'Prüfgerät',
    txt_ddmd: 'Anlass',
    txt_lic: 'Kilometerstand',
    txt_chex: 'Autotyp',
    txt_jcjyi: 'Inspektionsvorschläge',
    txt_ysbs: 'Beschreibung über Laufflächenabnutzung',
    txt_ztms: 'Gesamter Verschleiß',
    txt_hwms: 'ungleichmäßige ',
    txt_dqscjltx: 'Erinnerung des aktuellen Bremswegs',
    txt_bgxqts: '备注：该测试由独立测试中心天津汽车检测中心进行，所用车辆为奥迪品牌FV7203BECGB型乘用车，轮胎规格为：245/40 R18,轮胎充气压力为：前胎230kpa，后胎220kpa；测试场地为：卡达克盐城测试地；所计算的车辆制动距离的速度范围:从100公里/小时减速至0公里/小时。',
    txt_wxsmgz: '微信扫码关注 TyreHub 公众号',
    txt_hwmsjh: 'Gleichmäßige Abnutzung bei Reifenprofil',
    txt_zqlun: 'L-F',
    txt_zhlun: 'L-R',
    txt_yqlun: 'R-F',
    txt_yhlun: 'R-R',
    txt_pingjunzhi: 'Durchschnittlicher Wert:',
    txt_guige: 'Größe',
    txt_gongli: 'KM',
    txt_ltwjc: '轮胎未检测',

    txt_ltws: 'Reifen außen',
    txt_sewmts: 'Scan To Report',
    txt_print: 'Print',





    //店员管理
    txt_xz: 'Auswählen',
    txt_qy: 'Aktivieren',
    txt_qyz: 'Aktivieren',
    txt_ty: 'Deaktivieren',
    txt_yhzh: 'Benutzerkonto',
    txt_lxfs: 'Kontakt',
    txt_cjsj: '创建时间',
    txt_bjxx: 'Bearbeiten',
    txt_xgmm: 'Passwort ändern',
    txt_bgzt: 'Status ändern',
    txt_qdytjm: '确定要将账号{0}{1}吗？',
    txt_tjdy: 'Auswählen',
    txt_bjdyxx: 'Bearbeiten',
    txt_zhxx: '账号信息',
    txt_ygxm: 'Name',
    txt_qtxygxm: '请填写员工姓名',
    txt_lxdh: '联系电话',
    txt_qtxyglxdh: '请填写员工联系电话',
    txt_dxyzm: '短信验证码',
    txt_qtxdxyzm: '请填写短信验证码',
    txt_fsdx: '发送短信',
    txt_tjzh: 'Auswählen',
    txt_baocun: '保存',
    txt_gtgygzh: '共{0}个员工账号',



    //登录
    txt_qdytcdlm: '确定要退出登录吗',
    txt_qx: 'Abbrechen',
    txt_dl: '登录',
    txt_qsrzh: 'Bitte geben Sie Ihre Konto- oder Telefonnummer ein',
    txt_qsrmm: '请输入密码',
    txt_zcshzh: '注册商户账号',
    txt_shzhwjmm: '商户账号忘记密码',
    txt_yzdqmm: 'Bitte überprüfen Sie das aktuelle Passwort',
    txt_szxmm: 'Bitte geben Sie ein neues Passwort ein',
    txt_xgcg: 'erfolgreich geändert:',
    txt_qtxjmm: 'Bitte geben Sie das alte Passwort ein.',
    txt_yzzcsj: 'Überprüfen Sie das registrierte Handy',
    txt_qtxxmm: '请填写新密码',
    txt_qzctxxmm: '请再次填写新密码',
    txt_lcmmsrbyz: '两次密码输入不一致',
    txt_gxnxgcg: 'Gratulieren Sie, dass Sie das Passwort erfolgreich geändert haben.',
    txt_qljndxmm: '请牢记你的新密码',
    txt_fhgrzx: '返回个人中心',
    txt_fsyzm: 'Sicherheitscode senden.',
    txt_qtxzcsjh: '请填写注册手机号',
    txt_qtxtxyzm: 'Bitte geben Sie den grafischen Bestätigungscode ein.',
    txt_qsryzm: 'Bitte geben Sie den Bestätigungscode ein',
    txt_qszhhmm: 'Bitte geben Sie ein neues Passwort, das aus 6-18 Ziffern und Buchstaben besteht, ein',
    txt_qzcsrmm: 'Bitte geben Sie das Passwort erneut ein.',
    txt_lcmmbyz: '两次密码输入不一致',
    txt_hdsy: '去首页',
    txt_zcshh: '注册商户号',
    txt_fhdl: 'Zurück zum Login.',
    txt_wlqqsb: '网络请求失败，请重试',
    txt_wczc: 'Abgeschlossen',
    txt_wsts: 'Bitte vervollständigen Sie vor der Verwendung die Detailinformationen',
    txt_qtxshmc: '请填写商户名称',
    txt_shmc: '商户名称',
    txt_rgszjd: 'Wie Firmennummer, anderes Telefon, Fax, etc.',
    txt_qtlxfs: 'Andere Kontaktinformationen',
    txt_kssy: 'Bitte verwenden Sie',
    txt_Pwear1: 'ungleichmäßige',
    txt_open: 'aktivieren',
    txt_close: 'deaktivieren',
    txt_srczhdmm: '输入重置后的密码',
    txt_kcfs: '{0}后可重发',
    txt_xiugai: 'ändern',
    txt_zzjzsj: '正在加载数据',
    txt_bjshxx: 'Bearbeiten',
    txt_chongxinhq: '重新获取',
    txt_gaibangsj: '改绑手机',
    txt_yanzhengjsj: '验证旧手机',
    txt_bangdingxsj: '绑定新手机',
    txt_yhqsyxsjdl: '以后请您使用新手机号登录',



    //登录新
    txt_xzshenfen: '请选择您的身份',
    txt_dlrolewz: '登录{0}号',
    txt_qsrsjh: 'Bitte geben Sie Ihre Konto- oder Telefonnummer ein',
    txt_zhuce: 'Registrieren',
    txt_wanjimima: 'Passwort vergessen',
    txt_wanshandzxx: '完善店长号资料',
    txt_qsrxm: '请输入姓名',
    txt_qsrmdm: '请输入门店名',
    txt_qsrmdgddh: '请输入门店固定电话',
    txt_qsrmddz: '请输入门店地址',
    txt_qsrgsdz: '请输入公司地址',
    txt_qsrxxdz: '请输入详细地址',
    txt_tijiaocg: '提交成功',
    txt_qsvbsylwmm: '请设置不少于6位密码',
    txt_zhucerole: 'Account register {0}',
    txt_qsrshh: '请输入商户号',
    txt_qsrdzh: '请输入店长号',
    txt_wsshhzl: '完善商户号资料',
    txt_wsdyhzl: '完善店员号资料',
    txt_qsrshm: '请输入商户名(公司名称)',
    txt_qsrshz: '请输入商户主(负责人)',
    txt_qsrzrqy: '请输入责任区域(工作部门)',
    txt_shanghudizhi: '商户地址',
    txt_yhycz: '用户已存在',
    txt_qsrzqdzh: '请输入正确店长号',
    txt_qsrzqshh: '请输入正确商户号',
    txt_xzmdcx: '选择门店查询',



    //门店
    txt_mendianId: '门店ID',
    txt_mendianmc: '门店名称',
    txt_mendiandz: '门店地址',
    txt_mendiandh: '门店电话',
    txt_caozuo: '操作',
    txt_mendiangl: 'Laden verwalten',
    txt_gjmendian: '共 {0} 家门店',
    txt_zhengchangyy: 'Offen',
    txt_tingye: 'Geschlossen',
    txt_gengdxx: 'Mehr',
    txt_dianygl: '店员管理',
    txt_biangzt: 'Status ändern',
    txt_qdygbzhuangtai: 'Bestätigen Sie, den Geschäftsstatus von {0} in {1} zu ändern?？',
    txt_bjmendian: 'Bearbeiten',
    txt_xinzenmd: '新增门店',
    txt_qtxmdmc: '请填写门店名称',
    txt_qxzmddz: 'Bitte wählen Sie die Adresse aus',
    txt_qtxxdz: '请填写详细地址',
    txt_xiangxidz: 'Detaillierte Adresse',
    txt_qtxmddh: 'Bitte geben Sie die Telefonnummer ein',
    txt_dzxx: '店长信息',
    txt_chaungjianmendian: 'Laden erstellen',
    txt_mendianxxxx: '门店详细信息',
    txt_bianji: 'Bearbeiten',
    txt_mendianzt: 'Status speichern',

    //商户数据总览
    txt_mendianshuju: '门店数据',
    txt_chakangdxxbb: '查看更多详细报表',
    txt_jczcs: '检测总次数',
    txt_mdpjjc: '门店平均检测',
    txt_jdzcl: '进店总车辆',
    txt_jcl: '检测率',
    txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
    txt_xyghltjgfb: '需更换轮胎的结果分布',
    txt_xzzyltjgfb: '需注意轮胎的结果分布',
    txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
    txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
    txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
    txt_jrzl: '今日总览',
    txt_xiangqbb: '详情报表',
    txt_xuanzerqckxxsj: '选择日期查看详细数据',
    txt_qxzsjd: 'Voraussichtliche Zeit',
    txt_sjdts: '最多只能选择30天以内的时间段',
    txt_zonglan: '总览',
    txt_qushi: '趋势',
    txt_shuliangtj: '数量统计',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: '检测次数趋势',
    txt_msqkslqs: '轮胎磨损情况数量趋势',
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: '检测次数',
    txt_shuliang: '数量',
    txt_zhanbi: '占比',
    txt_chankangd: '查看更多',
    txt_chakanmdxxbb: '查看门店详细报表',


    //国家
    txt_zhongguo: '中国',
    txt_mlxy: '马来西亚',
    txt_yindu: '印度',
    txt_taiguo: '泰国',
    txt_oluosi: '俄罗斯',



    txt_taici: '台次',
    txt_jianyi: 'Vorschlag:',
    txt_jianyineirong: 'Unregelmäßige Abnutzung, Rotation, etc. entstehen, bitte führen Sie eine weitere Prüfung durch',
    txt_jianyineirongzc: 'Normal',
    txt_bgtixing: 'Bermerkung:',
    txt_bgtuxubfnr: 'Dem aktuellen Abnutzungsstatus nach könnte der Bremsweg um {0}% erhöht (Bewertungswert)',
    txt_waishang: 'Reifentrauma',
    txt_laohua: 'Alterung',
    txt_gubao: 'Beule',
    txt_xichemeirong: 'Autowäschee & -schönheit',
    txt_weixiubaoyang: 'Wartung',
    txt_guenghuanluntai: 'Reifenwechsel',
    txt_scsltjcy: 'Handreifendetektor',
    txt_shijiantishi: '结束时间必须大于开始时间',
    txt_pinpai: 'Marke',
    txt_qxzclry: '请选择处理人员',

    txt_lf_outworn: 'Die Außenseite des linken Vorderreifens ist schlimmer als die Innenseite abgenutzt.',
    txt_lf_innerworn: 'Die Innenseite des linken Vorderreifens ist schlimmer als die Außenseite abgenutzt.',
    txt_lf_bothsideworn: 'Die beiden Seiten des linken Vorderreifens sind schlimmer als die Mitte abgenutzt.',
    txt_lf_centreworn: 'Die Mitte des linken Vorderreifens ist schlimmer als die beiden Seiten abgenutzt.',
    txt_lb_outworn: 'Die Außenseite des linken Hinterreifens ist schlimmer als die Innenseite abgenutzt.',
    txt_lb_innerworn: 'Die Innenseite des linken Hinterreifens ist schlimmer als die Außenseite abgenutzt.',
    txt_lb_bothsideworn: 'Die beiden Seiten des linken Hinterreifens sind schlimmer als die Mitte abgenutzt.',
    txt_lb_centreworn: 'Die beiden Seiten des linken Hinterreifens sind schlimmer als die Mitte abgenutzt.',
    txt_rb_outworn: 'Die Außenseite des rechten Hinterreifens ist schlimmer als die Innenseite abgenutzt.',
    txt_rb_innerworn: 'Die Innenseite des rechten Hinterreifens ist schlimmer als die Außenseite abgenutzt.',
    txt_rb_bothsideworn: 'Die beiden Seiten des rechten Hinterreifens ist schlimmer als die Mitte abgenutzt.',
    txt_rb_centreworn: 'Die Mitte des rechten Hinterreifens ist schlimmer als die beiden Seiten abgenutzt.',
    txt_rf_outworn: 'Die Außenseite des rechten Vorderreifens ist schlimmer als die Innenseite abgenutzt.',
    txt_rf_innerworn: 'Die Innenseite des rechten Vorderreifens ist schlimmer als die Außenseite abgenutzt.',
    txt_rf_bothsideworn: 'Die beiden Seiten des rechten Vorderreifens ist schlimmer als die Mitte abgenutzt.',
    txt_rf_centreworn: 'Die Mitte des rechten Vorderreifens ist schlimmer als die beiden Seiten abgenutzt.',
    txt_tire_need_replace: 'Abnutzungen beim Reifen, sofort wechseln',
    txt_tire_boundary: 'Abnutzungen beim Reifen, im Grenzzustand',
    'txt_tire_boundary;': 'Abnutzungen beim Reifen, im Grenzenstatus',
    txt_alignment_chassis: 'Eine weitere 4-Rad-Ausrichtung oder eine Prüfung beim Fahrgestell wird vorgeschlagen ',
    txt_wear_uniform: 'Regelmäßige Abnutzung bei einzelnem Reifen',
    'txt_wear_uniform;': 'Regelmäßige Abnutzung bei einzelnem Reifen',
    txt_do_further_check: 'Bitte führen Sie eine weitere Prüfung durch',
    txt_uneven_check: 'Unregelmäßige Abnutzung, eine weitere Prüfung wird vorgeschlagen',
    'txt_uneven_check;': 'Unregelmäßige Abnutzung, eine weitere Prüfung wird vorgeschlagen',
    txt_tire_rotation: 'Reifenrotation wird vorgeschlagen',
    txt_wear_normal: 'Normale Abnutzung bei Reifenprofil',
    'txt_wear_normal;': 'Normale Abnutzung bei Reifenprofil',
    txt_tire: 'Tire',
    txt_xiazai: 'Download',
    txt_xiazaishibai: 'Fail',
    txt_wheelalignment: 'Need to do dynamic balance and wheel alignment',
    txt_fanhui: 'Return',
    txt_yszc: '隐私政策',
    txt_djtyjbsydty: '点击同意即表示您已经阅读并同意',
    txt_djyszc: '《tyrehub隐私政策》',
    txt_tongyi: '同意',
    txt_btongyi: '不同意',
    txt_yszcnr: '【请您注意】如果您不同意上述协议或其中任何条款约定，请您停止注册。您停止注册后无法享受我们的服务。如果您按照注册流程填写信息，阅读并且点击同意上述协议且全部完成注册流程后，表示您已充分阅读，理解并且接受协议的全部内容。',
    txt_qsrszcs: '请输入所在城市',
    txt_qsrszsf: '请输入所在省份',
    txt_qwsxx: '请完善信息',
    txt_shujufx: '数据分享',
    txt_fenxiang: '分享',
    txt_djxybbs: '点击下一步表示你已阅读并同意',
    txt_yhxy: '《用户协议》',
    txt_xxfxsz: 'Setting',
    txt_jsfzh: '接收方账号',
    txt_xzfxxx: '选择分享信息',
    txt_jianceliang: '检测量',
    txt_fenxiangjieshu: '分享结束时间',
    txt_jieshou: '接收',
    txt_jujue: '拒绝',
    txt_jieshoufenxiang: '接受分享',
    txt_jieshoushanghu: '接收商户:',
    txt_zhongzhi: '终止',
    txt_fenxiangzhong: '分享中',
    txt_fenxiangshanghu: '分享商户',
    txt_jieshouzhong: '接收中',
    txt_sousuo: '搜索',
    txt_jiance: 'Prüfung',
    txt_fenxiangtishi: '对方没有分享此数据给您，无权查看',
    //报告新增 
    'txt_tire_age_5': 'Der Reifenalter hat 5 Jahre überschritten, es wird empfohlen, den Reifen auszutauschen.',
    'txt_tire_age_3': 'Bei reifenspuren, die bereits mehr als 3 jahre alt sind, empfiehlt es sich eine gründliche inspektion',
    'txt_tire_age_8': 'Der Reifenalter hat 8 Jahre überschritten, es wird empfohlen, den Reifen auszutauschen.',
    'txt_tire_age_6': 'Bei reifenspuren, die bereits mehr als 6 jahre alt sind, empfiehlt es sich eine gründliche inspektion',
    'txt_tire_age_ok': 'Die reifen sollten erneuert werden',
    'txt_tire_age_ok;': 'Die reifen sollten erneuert werden',
    'txt_tire_trauma_check': 'Die Reifenoberfläche ist beschädigt, weitere Inspektion wird empfohlen',
    'txt_install_abnormal_check': 'Reifenmontage ist abnormal, weitere Inspektion wird empfohlen',
    'txt_tire_appearance_ok': 'Gutes Reifenbild',
    'trauma_lacerate': 'Lacerat',
    'trauma_dropblock': 'Block fallenlassen',
    'trauma_puncture': 'Punktion',
    'trauma_scratch': 'Kratzen',
    'txt_tire_age': 'Reifenalter',
    'txt_tire_appearance': 'Reifen außen',
    //未翻译

    txt_plcl: 'Batch',
    txt_qbxz: 'All',
    txt_scjcjg: 'Last',
    txt_ltxhlcgs: 'Schätzung der Reifenlaufleistung',
    txt_ltazhuang: 'Installation:',
    txt_wear_overall: 'Gesamter Verschleiß',
    txt_pattern_wear: 'Anormaler Verschleiß',

    txt_ltlcgstm: 'Nach der aktuellen Reifenverschleißsituation beträgt die Reifenkilometer {0} km (geschätzter Wert)',
    txt_yichang: 'Abnormal',
    txt_qjybjcltazqk: 'Bitte überprüfen Sie die Reifeninstallation',
    txt_dottx: 'geschätztes Reifenalter',
    txt_dottxjy: 'Reifen werden seit mehr als drei Jahren verwendet, überprüfen Sie sie bitte regelmäßig',
    txt_danweinian: '(Einheit:Jahr)',
    txt_danweikm: '(Einheit:km)',
    txt_shurujb: "Geben Sie ’Ungebunden‘ ein, um das Gerät zu deaktivieren",
    txt_shuruzqwa: 'Bitte geben Sie den gewünschten Text ein',
    txt_myhqdsj: 'DOT zeit nicht erhalten',
    txt_dotjstx: 'Die Restlaufzeit des Reifens beträgt etwa {0} Tage',
    txt_dotjstx2: 'Die Lebensdauer der Reifen hat fünf Jahre überschritten, bitte ersetzen Sie sie sofort',
    txt_dotsjztx: '(Dot Time: Reifenfertigungsdatum)',
    txt_gelie: 'komplette Zerstörung',
    txt_diaokuai: 'Verschleiß an mehreren Stellen Lauffläche',
    txt_chaungci: 'Beschädigung durch fremde Körper',
    txt_cashang: 'Kratzen',
    txt_yichang: 'Abnormal',
    'txt_tire_need_replace;': 'Abnutzungen beim Reifen, sofort wechseln',
     //cormach
     txt_hood:'Kapuze',
     txt_wash_liquid:'Waschmittel',
     txt_level_control:'Level Control',
     txt_haoxiaoxi:'Normal',
     txt_vedi_Note:'Arbeitsplanung ',
     txt_replace1:'Ersatz: Sofort Arbeiten',
     txt_radiator_fluid:'Heizkörper Flüssigkeit',
     txt_engine_oil:'Motoröl',
     txt_brake_fluid:'Bremsflüssigkeit',
     txt_quality_control:'Qualitätskontrolle',
     txt_multimeter:'Multimeter-Test',
     txt_subtotal:'Zwischensumme',
     txt_shock_absorber:'Stoßdämpfer',
     txt_check_loss:'sichtbarer Verlust überprüfen',
     txt_brake_disc:'Bremsscheibe',
     txt_wear_condition:'Verschleißzustand',
     txt_brake_pads:'Bremsbeläge',
     txt_change_control:'Change Control',
     txt_air_control:'Klimaanlage',
     txt_last_reload:'Last Reload',
     txt_lighting:'Beleuchtung',
     txt_verification1:'Wischer',
     txt_dynamometer:'Anziehen des Prüfstands',
     txt_batteria:'Batterie',
     txt_verification:'Verifikation',
     txt_levellow:'Normal',
     txt_levelmiddle:'Arbeitsvorbereitung',
     txt_levelhigh:'Ersetzen',
     txt_tyrenumber:'Scan Depth:',
     txt_cormach_title:'Wear & Exzentric Wear',
     txt_wearlow:'Even Pattern Wear',
     txt_wearmiddle:'Leichte Abnutzung',
     txt_wearhigh:'Schwere Verschleiß',
     txt_namtishi:'32 Grad Tiefe der Lauffläche',
     txt_zhiliangkongzhi:'Qualitätskontrolle',
     txt_buchongzhengduan:'ergänzende Diagnose',
     txt_season_summer:'Ihre Sommerreifen',
     txt_season_winter:'Die Winterreifen',

    //未翻译
    txt_msjxtx: 'Der Reifen hat die Grenze erreicht, ersetzen Sie ihn bitte sofort',
    txt_ltfz: 'inverse internal and external installation',
    txt_jishimz: 'Techniker',
    txt_ltlcgsnew: 'Reifenlaufleistung {0} km',
    txt_ltlcgsnewin: 'Tire range is {0} miles',
    txt_pinnate_check: 'Die Reifen haben gefiederte Gebrauchsspuren.Es wird empfohlen, die Fahrwerksteile weiter zu überprüfen.',
    txt_pinnate_wear: 'Feder tragen',

    txt_install_check: 'Installationsprüfung',
    txt_install_ok: 'Normale Installation',
    LF:'[L-F]',
    RF:'[R-F]',
    LB:'[L-R]',
    RB:'[R-R]',
    FF:'[F-F]',
    BB:'[B-B]',
    txt_appearance_check: 'Der Reifen hat sichtbare Beschädigung, bitte bestätigen Sie ihn zur Reparatur.',
    txt_uneven_center: 'Abnormale Abnutzung in der Mitte des Reifens. Es wird empfohlen, den Reifendruck zu überprüfen',
    txt_uneven_out: 'Die äußere Seite des Reifens wird abnormal getragen. Es wird empfohlen, die Vierrad-Ausrichtung und Reifendruck zu überprüfen',
    txt_pinnate_check: 'Es gibt Federverschleiß auf dem Reifen. Es wird empfohlen, die Fahrgestellteile weiter zu prüfen',
    txt_uneven_inside: 'Die innere Seite des Reifens wird abnormal getragen. Es wird empfohlen, die Vierrad-Ausrichtung und Reifendruck zu überprüfen',
    txt_uneven_bothside: 'Abnormale Abnutzung auf beiden Seiten des Reifens. Es wird empfohlen, die Vierrad-Ausrichtung und Reifendruck zu überprüfen.',
    
    txt_msyzljgh:'Der Reifen ist stark gegenutzt, sofort ersetzen.',
    txt_serious_trauma_check:"Der Reifen hat schwere sichtbare Beschädigung. Es wird empfohlen, den Reifen auszutauschen.",
    txt_appearance_lookup:"Bitte überprüfen Sie das Aussehen der Reifen",
    txt_wear_lookup :"Bitte überprüfen Sie Reifenverschleiß",
    txt_dotscsj:'DOT: {0} ({1} Jahr {2} Woche)',
    txt_whqdscsj:'Keine Herstellungszeit',
    purp_tireservice:'Reifenservice',
    purp_vehicle_inspection:'Inspektion des Fahrzeugs', 
    txt_chassis_check :'Fahrgestellprüfung',
    txt_chassis_ok:'Fahrwerk ist gut',
    txt_chassis_oil:'Der Stoßdämpfer leckt Öl. Es wird empfohlen, ihn bei Bedarf weiter zu bestätigen und zu ersetzen.',
    txt_chassis_aging :'Der Gummi des Wellenkopfes altert, so dass es empfehlenswert ist, ihn zu ersetzen.',
    txt_trauma_eattyre:'Iss das Baby',
    txt_uneven_eattyre:'Es wird empfohlen, das dynamische Auswuchten durchzuführen und das Vier-Rad-Ausrichtungs- und Federungssystem zu überprüfen, wenn der Reifen isst',
    txt_appearance_eattyre:'Es wird empfohlen, das dynamische Auswuchten durchzuführen und das Vier-Rad-Ausrichtungs- und Federungssystem zu überprüfen, wenn der Reifen isst',
    txt_chassis_eattyre:'Es wird empfohlen, das Vierrad-Ausrichtungs- und Federungssystem zu überprüfen, wenn der Reifen frisst',
    txt_uneven_high_eattyre:'Wenn der Reifen schwer beschädigt ist, empfiehlt es sich, den Reifen zu wechseln und das Vierrad-Ausrichtungs- und Federungssystem zu überprüfen',
    txt_appearance_high_eattyre:'Wenn der Reifen schwer beschädigt ist, empfiehlt es sich, ein dynamisches Auswuchten durchzuführen und das Vierrad-Ausrichtungs- und Federungssystem zu überprüfen',
    txt_chassis_high_eattyre:'Es wird empfohlen, das Vierrad-Ausrichtungs- und Federungssystem zu überprüfen, wenn der Reifen ernsthaft beschädigt ist',
    txt_chassis_uneven:'Wenn der Reifen abnormal getragen ist, empfiehlt es sich, das Vierrad-Ausrichtungs- und Federungssystem zu überprüfen',
    txt_pianmoyichang:'abnormale Reifenexzentrische Abnutzung',

  
    txt_khxm:'Kundenname',
    txt_khyx:'Kundenemail',

    txt_qiao: 'Achse',
    txt_left: 'Links',
    txt_right: 'Rechts',
    txt_lun: '轮',
    txt_huawen: 'Muster',
    txt_taihao: 'Reifennummer',
    txt_taiya: 'Reifendruck',
    txt_chexlw: 'Autotyp',
    txt_jiancerenyuan: 'Techniker',
    txt_beitai:'Reserve',
    txt_tuoche:'Traktor',
    txt_guache:'Traktor',

    txt_tireplace:'Lgerort',
    txt_season_all:'Ihre Allwetterreifen',
    txt_season_other:'Andere',
    txt_bolt:'Andere Radbolzen',
    txt_goods_name:'Handelsname',
    txt_yes:'Ja',
    txt_no:'Nein',
}


// WEBPACK FOOTER //
// ./src/i18n/ger.js